'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _uploads = require('helpers/uploads');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var getElementProps = function getElementProps(actualProps) {
  var actualPropsCopy = (0, _extends3.default)({}, actualProps);
  var expectedPropNames = (0, _keys2.default)(DropzoneElement.propTypes); // eslint-disable-line no-use-before-define
  expectedPropNames.forEach(function (expectedPropName) {
    return delete actualPropsCopy[expectedPropName];
  });
  return actualPropsCopy;
};

var DropzoneElement = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DropzoneElement, _Component);

  function DropzoneElement() {
    (0, _classCallCheck3.default)(this, DropzoneElement);
    return (0, _possibleConstructorReturn3.default)(this, (DropzoneElement.__proto__ || (0, _getPrototypeOf2.default)(DropzoneElement)).apply(this, arguments));
  }

  (0, _createClass3.default)(DropzoneElement, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(DropzoneElement.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropzoneElement.prototype), 'componentDidMount', this).call(this, this._registerDropzone);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled !== this.props.disabled) {
        if (nextProps.disabled) {
          this._unregisterDropzone();
        } else {
          this._registerDropzone();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._registerDropzone();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get3.default)(DropzoneElement.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropzoneElement.prototype), 'componentWillUnmount', this).call(this, this._unregisterDropzone);
    }
  }, {
    key: '_unregisterDropzone',
    value: function _unregisterDropzone() {
      if (this._qqDropzone) {
        this._qqDropzone.dispose();
      }
    }
  }, {
    key: '_onDropError',
    value: function _onDropError(errorCode, errorData) {
      var onDropError = this.props.onDropError;

      if (onDropError) {
        onDropError((0, _uploads.getUploaderErrorMessage)(errorCode), errorData);
      }
    }
  }, {
    key: '_onProcessingDroppedFilesComplete',
    value: function _onProcessingDroppedFilesComplete(files) {
      var _props = this.props,
          uploader = _props.uploader,
          onProcessingDroppedFilesComplete = _props.onProcessingDroppedFilesComplete;

      uploader.methods.addFiles(files);
      if (onProcessingDroppedFilesComplete) {
        onProcessingDroppedFilesComplete(files);
      }
    }
  }, {
    key: '_registerDropzone',
    value: function _registerDropzone() {
      if (this.props.disabled) {
        return false;
      }

      this._unregisterDropzone();

      var _props2 = this.props,
          element = _props2.element,
          multiple = _props2.multiple,
          onProcessingDroppedFiles = _props2.onProcessingDroppedFiles,
          dropActiveClassName = _props2.dropActiveClassName;

      var dropzoneEl = element || this.dropZone;
      var dnd = require('fine-uploader/lib/dnd');

      this._qqDropzone = new dnd.DragAndDrop({
        allowMultipleItems: !!multiple,
        callbacks: {
          dropError: this._onDropError,
          processingDroppedFiles: onProcessingDroppedFiles || function () {},
          processingDroppedFilesComplete: this._onProcessingDroppedFilesComplete
        },
        classes: {
          dropActive: dropActiveClassName || 'active'
        },
        dropZoneElements: [dropzoneEl]
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./FineUploader.scss');
      var _props3 = this.props,
          className = _props3.className,
          children = _props3.children,
          clickable = _props3.clickable;

      var dropZoneClass = (0, _bind2.default)(className, styles.dropZone, (0, _defineProperty3.default)({}, styles.clickable, clickable));

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, getElementProps(this.props), { className: dropZoneClass, ref: function ref(el) {
            return _this2.dropZone = el;
          } }),
        children
      );
    }
  }]);
  return DropzoneElement;
}(_ClientSideComponent2.default), _class2.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  className: _propTypes2.default.string,
  clickable: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  dropActiveClassName: _propTypes2.default.string,
  element: _propTypes2.default.string,
  multiple: _propTypes2.default.bool,
  onDropError: _propTypes2.default.func,
  onProcessingDroppedFiles: _propTypes2.default.func,
  onProcessingDroppedFilesComplete: _propTypes2.default.func,
  uploader: _propTypes2.default.object.isRequired
}, _temp), (_applyDecoratedDescriptor(_class.prototype, '_unregisterDropzone', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_unregisterDropzone'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_onDropError', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_onDropError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_onProcessingDroppedFilesComplete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_onProcessingDroppedFilesComplete'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_registerDropzone', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_registerDropzone'), _class.prototype)), _class);
exports.default = DropzoneElement;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/DropZone.js
// module id = 1993
// module chunks = 1